export const siteContents = [{ id: 'MEDIA', text: 'Média megjelenések' }];
